import { Grid, TextField, Typography } from "@mui/material"
import { KaziCountries } from "../../../../Shared Components/Kazi/KaziCountries"
import { Control, Controller, UseFormGetValues } from "react-hook-form"
import { KaziPhoneNumber } from "../../../../Shared Components/Kazi/KaziPhoneNumber"
import { useMobileView } from "../../../../Hooks/useMobileView"

interface EditAccountLocationInfoProps {
    control: Control<any, any>
    getValue: UseFormGetValues<any>
}
export const EditAccountLocationInfo = ({ control, getValue }:EditAccountLocationInfoProps) => {
    /* ******************** Hooks ******************** */
    const { flexDirection } = useMobileView();
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <>
            <Grid item display={"flex"} flexDirection={flexDirection} gap={'12px'}>
                <Grid  item display={"flex"} flexDirection={"column"} flex={1}>
                    <Typography variant='body-small' color={'black.200'} marginBottom={1}>Country*</Typography> 
                    <Controller
                        name='country'
                        control={control}
                        render={({field}) =>(
                            <KaziCountries
                                {...field}
                            />
                        )}
                    />
                </Grid>                            
                <Grid  item display={"flex"} flexDirection={"column"} flex={1}>
                    <Typography variant='body-small' color={'black.200'} marginBottom={1}>Phone number</Typography> 
                    <Controller
                        name='phone'
                        control={control}
                        render={({field}) =>(
                            <KaziPhoneNumber
                                {...field}
                                format={getValue('country')}
                                fullWidth
                                sx={{
                                    marginBottom: "16px",
                                    minWidth: "300px"
                                }}
                            />
                        )}
                    />
                </Grid>
            </Grid>
            <Grid>
                <Typography variant="body-small" color={'black.200'}>
                    *If you update this information, your change will need to be approved. It may take some time to see this information updated in your account info.
                </Typography>
            </Grid>
        </>
    )
}